import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Column } from '@miq/catalog';
import { KpisResult } from './kpi-summary-columns.helper';
import { formatNumber } from '@miq/utils';

@Component({
  selector: 'miq-kpi-summary',
  templateUrl: './kpi-summary.component.html',
  styleUrls: ['./kpi-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KpiSummaryComponent {
  @Input() kpisValue: KpisResult;
  @Input() set numberofRecords(limit) {
    limit = !limit || isNaN(limit) ? 5000 : limit;
    this._limit = formatNumber(limit);
  }
  @Input() kpisColumns: Partial<Column>[];
  @Input() showInfoIcon = false;
  private _limit: string;

  get limit(): string {
    return this._limit;
  }
}
